import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from 'styled-components';
import { queryClient } from '../lib/query/queryClient';
import { ToastProvider } from '../shared/components/Toast/ToastProvider';
import { AuthProvider } from '../features/auth/context/AuthContext';
import { theme } from './theme';
import { GlobalStyle } from './GlobalStyle';

// Single composition point for all app-wide providers.
export const AppProviders = ({ children }) => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <ToastProvider>
        <AuthProvider>
          {children}
        </AuthProvider>
      </ToastProvider>
    </ThemeProvider>
  </QueryClientProvider>
);
